import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/ApiService';
import Navigation from '../components/Navigation';
import Avatar from '../components/Avatar';
import './Matches.css';

interface Match {
  id: number;
  matchedUser: {
    id: number;
    name?: string;
    profile?: {
      variant?: {
        name: string;
      };
      bio?: string;
      photoUrl?: string;
    };
  };
  lastMessage?: {
    content: string;
    createdAt: string;
  };
  createdAt: string;
}

const Matches: React.FC = () => {
  const [matches, setMatches] = useState<Match[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchMatches();
  }, []);

  const fetchMatches = async () => {
    try {
      const response = await ApiService.get('/matches');
      setMatches(response.data);
    } catch (error) {
      console.error('Failed to fetch matches:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMatchClick = (matchId: number) => {
    navigate(`/chat/${matchId}`);
  };

  if (loading) {
    return (
      <>
        <Navigation />
        <div className="matches-container">
          <p>Loading...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navigation />
      <div className="matches-container">
        <h1>Your Matches</h1>

        {matches.length === 0 ? (
          <div className="no-matches">
            <p>You don't have any matches yet.</p>
            <button onClick={() => navigate('/browse')} className="browse-button">
              Start Browsing
            </button>
          </div>
        ) : (
          <div className="matches-list">
            {matches.map((match) => (
              <div
                key={match.id}
                className="match-card"
                onClick={() => handleMatchClick(match.id)}
              >
                <Avatar
                  photoUrl={match.matchedUser.profile?.photoUrl}
                  name={match.matchedUser.name}
                  size="medium"
                />
                <div className="match-content">
                  <div className="match-info">
                    <h3>{match.matchedUser.name || 'Anonymous'}</h3>
                    {match.matchedUser.profile?.variant && (
                      <span className="variant-tag">
                        {match.matchedUser.profile.variant.name}
                      </span>
                    )}
                  </div>

                  {match.lastMessage ? (
                    <p className="last-message">{match.lastMessage.content}</p>
                  ) : (
                    <p className="no-messages">Start a conversation!</p>
                  )}

                  <p className="match-date">
                    Matched {new Date(match.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Matches;
